import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { forum_post_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';

import { ForumPost } from '../../interfaces/homepage';
import AuthorUnit from './AuthorUnit';

interface ForumPostItemProps {
  forumPost: ForumPost;
}

const ForumPostItem = ({
  forumPost: { id, title: forumPostTitle, author },
}: ForumPostItemProps) => {
  const { trackEvent } = useEventTracking({
    contentType: ContentType.ForumPost,
    contentId: id,
    creatorIds: [author.id],
  });
  return (
    <div className="border-0 border-r border-solid border-grayscale-gray px-28 first:pl-0 last:border-r-0 last:pr-0">
      <h4 className="m-0 mb-24 font-suisse-neue text-body-md">
        <a
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ForumHeadline }))}
          href={forum_post_path(id)}
          className="text-black"
        >
          {forumPostTitle}
        </a>
      </h4>
      <AuthorUnit author={author} />
    </div>
  );
};

export default ForumPostItem;
